var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3557 1.68718C10.7129 1.16417 9.76548 1.32832 9.3292 2.03829L4.69337 9.58233C4.60753 9.72202 4.6121 9.90038 4.70498 10.0353C4.87147 10.2772 5.22711 10.2666 5.37934 10.0152L8.48712 4.8817L9.47056 5.49759L6.36277 10.631C5.77497 11.602 4.40174 11.6431 3.75883 10.7089C3.40019 10.1878 3.38254 9.49917 3.714 8.95977L8.34984 1.41573C9.15228 0.109889 10.8949 -0.192034 12.0772 0.769941C13.0801 1.58598 13.3231 3.03665 12.6424 4.14439L7.48675 12.5343C6.43814 14.2407 4.20723 14.7225 2.56734 13.5967C1.0211 12.5351 0.56706 10.4257 1.5358 8.80416L5.21059 2.65319L6.19758 3.26317L2.52279 9.41414C1.87415 10.4999 2.17816 11.9123 3.21348 12.6231C4.31151 13.3769 5.80527 13.0543 6.50738 11.9117L11.663 3.52183C12.0331 2.91957 11.901 2.13085 11.3557 1.68718Z",
    fill: "#262758",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.96c64968c34def62a9ab21a0985d1240.svg";
export { ForwardRef as ReactComponent };